module.exports = __webpack_public_path__ + "img/story0.c8277c79.webp";